import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type CommunityListItem } from 'models';
import { type ApiClientResponseError, type ResponseErrorDataObject } from 'common/services/api';
// TODO fix this import from different feature, probably target queries should be here instead
import { getEventsQueryKey } from 'features/communities/queries';
import { type TelehealthRequestFormValues } from '../../components/Telehealth/TelehealthRequestForm';
import { requestVisit } from '../../services';

export const useRequestVisit = () => {
  const queryClient = useQueryClient();

  return useMutation<
    undefined,
    ApiClientResponseError<ResponseErrorDataObject>,
    { data: TelehealthRequestFormValues; selectedCommunity: CommunityListItem }
  >({
    async mutationFn({ data, selectedCommunity }) {
      const serviceTypeForRequest = (data: TelehealthRequestFormValues, selectedCommunity: CommunityListItem) => {
        const metaToApply = [];
        const visitType = selectedCommunity?.meta?.serviceTypes?.find(
          (serviceType) => serviceType.name === data.visitType,
        );
        if (visitType) {
          metaToApply.push({ name: visitType.name, translations: visitType.translations });
        } else return [];

        const subOption = visitType.children?.find((child) => child.name === data.visitTypeSubOption);

        if (subOption) {
          metaToApply.push({ name: subOption.name, translations: subOption.translations });
        } else return metaToApply;

        const secondSubOption = subOption.children?.find((childItem) => childItem.name === data.visitTypeSubSubOption);

        if (secondSubOption) {
          metaToApply.push({ name: secondSubOption.name, translations: secondSubOption.translations });
        }

        return metaToApply;
      };

      await requestVisit({
        post_in_communities: selectedCommunity ? [{ id: selectedCommunity.id }] : [],
        html_content: data.htmlContent,
        text_content: data.textContent,
        description: data.textContent,
        start_time: data.startTime,
        view_permission: 'private',
        end_time: data.endTime,
        meta: {
          patient_type: selectedCommunity?.meta?.patientTypes?.find(
            (patientType) => patientType.name === data.patientType,
          ),
          service_type: serviceTypeForRequest(data, selectedCommunity),
        },
        event_type: 'telehealth_visit',
      });

      return undefined;
    },
    onSuccess() {
      queryClient.invalidateQueries(getEventsQueryKey({ type: 'upcoming' }));
    },
  });
};
